'use client'

import { Box } from '@mui/material'
import { SettingsModal } from '@/components'
import { useWalletData } from '@/utils'
import React, { Suspense, useState, useCallback } from 'react'
import { Field } from '@/state/swap/actions'
import { useDerivedSwapInfo } from '@/state/swap/hooks'
import { wrappedCurrency } from '@/utils/wrappedCurrency'
import { useUserSlippageTolerance } from '@/state/user/hooks'
import { ChartComponent } from '@/components/Chart/chart'
import { SlippageWrapper } from '@/components/Swap/SlippageWrapper'
import { ChartLineData01Icon } from '@/utils/icons'
import BackPackAd from '../Ad/backPack'
import SwapMain from './SwapMain'
import { SwapSkeleton } from '../common/Audio'
import { ChainId } from '@monadex/sdk'
const SwapDefaultMode: React.FC = () => {
  const [openSettingsModal, setOpenSettingsModal] = useState(false)
  const [openChart, setOpenChart] = useState(false)
  const { currencies } = useDerivedSwapInfo()
  const { chainId } = useWalletData()
  const chainToUse = chainId || ChainId.MONAD_TESTNET

  const token1 = wrappedCurrency(currencies[Field.INPUT], chainToUse)
  const token2 = wrappedCurrency(currencies[Field.OUTPUT], chainToUse)
  const [userSlippageTolerance] = useUserSlippageTolerance()

  const handleCloseSettingsModal = useCallback(() => {
    setOpenSettingsModal(false)
  }, [])

  const handleChartToggle = useCallback(() => {
    setOpenChart(prev => !prev)
  }, [])

  return (
    <div className='container mx-auto mt-10 flex flex-col-reverse p-2 2xl:flex-row items-center'>
      {/* {openChart && token1 != null && token2 != null && (
        <ChartComponent token1={token1} token2={token2} />
      )} */}
      <Box width='100%' mb={3} id='swap-page'>
        {openSettingsModal && (
          <SettingsModal
            open={openSettingsModal}
            onClose={handleCloseSettingsModal}
            defaultSlippage={userSlippageTolerance}
          />
        )}
        
        <Box className='flex justify-center items-center'>
          <BackPackAd />
        </Box>
        <Box className='flex justify-between w-full p-3 items-center max-w-[500px] mx-auto'>
          <div>
            <h3 className='font-medium text-xl'>Swap</h3>
          </div>
          <Box className='flex items-center' ml='auto'>
            <Box className='flex items-center gap-3 p-1'>
              <Suspense>
                <SlippageWrapper click={() => setOpenSettingsModal(true)} />
              </Suspense>
              {/* <ChartLineData01Icon
                className='cursor-pointer'
                onClick={handleChartToggle}
                width={24}
              /> */}
            </Box>
          </Box>
        </Box>
        <Suspense fallback={<SwapSkeleton />}>
          <Box className='flex flex-col max-w-[500px] justify-center items-center p-2 mx-auto rounded-2xl border border-primary shadow-sha border-opacity-25 bg-bgColor'>
            <Box sx={{ zIndex: 1, width: '100%' }} className='p-2'>
              <SwapMain />
            </Box>
          </Box>
        </Suspense>
      </Box>
    </div>
  )
}

export default SwapDefaultMode
